export enum TrackingEventNames {
  AccessCodeCopied = 'access_code_copied',
  AttendeeCsvDownloaded = 'attendee_csv_downloaded',
  AuthCodeRequested = 'auth_code_requested',
  ClientChanged = 'client_changed',
  CommunicationKitTemplateSelected = 'communication_kit_template_selected',
  DeleteEstablishment = 'delete_establishment',
  GameRankingDownloaded = 'game_ranking_downloaded',
  GameCreationModalClosed = 'game_creation_modal_closed',
  GameCreationNext = 'game_creation_next',
  GameCreationPrevious = 'game_creation_previous',
  GameCreationSubmit = 'game_creation_submit',
  GameRescheduleSubmitted = 'game_reschedule_submitted',
  ImportEstablishments = 'import_establishments',
  ImportGameEntities = 'import_game_entities',
  UserLoggedOut = 'user_logged_out',
}
